import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiGetAllPaginatedResponse, ApiGetAllResponse } from '../interfaces/api-get-all-response.interface';
import { ApiCreateSingleResponse } from '../interfaces/api-create-single-response.interface';

export interface Pagination {
    page: number;
    limit?: number | null;
}

export interface Filter {
    [key: string]: string;
}

export interface QueryParams {
    [key: string]: string;
}

export enum SortDir {
    Asc = 'ASC',
    Desc = 'DESC',
}

export interface Sort {
    field: string;
    type: SortDir;
}

@Injectable()
export abstract class AbstractApiService<ItemType> {
    public getAllPaginated(
        pagination: Pagination = { page: 1 },
        filter: Filter = {},
        sort: Sort | null = null,
        queryParams: QueryParams = {},
    ): Observable<ApiGetAllPaginatedResponse<ItemType>> {
        throw new Error('Not implemented');
    }

    public getAll(filter: Filter = {}, queryParams: QueryParams = {}): Observable<ApiGetAllResponse<ItemType>> {
        throw new Error('Not implemented');
    }

    public getSingle(resourceId: string, queryParams: QueryParams = {}): Observable<ItemType> {
        throw new Error('Not implemented');
    }

    public deleteSingle(resourceId: string): Observable<object> {
        throw new Error('Not implemented');
    }

    public createSingle(formData: FormData | object): Observable<ApiCreateSingleResponse> {
        throw new Error('Not implemented');
    }

    public updateSingle(resourceId: string, formData: FormData | object): Observable<object> {
        throw new Error('Not implemented');
    }
}
